module.exports = __webpack_public_path__ + "static/media/invoice-summary.6be43ec7.png";